import { TCoverageSideEffectsType } from 'sure-platform-sdk';

import { TCopyConfig } from '@@/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';

const ToggleMOCopy: DeepPartial<TCopyConfig> = {
  autoDiscounts: [
    AUTO_DISCOUNTS.antiTheft,
    AUTO_DISCOUNTS.safeDriving,
    AUTO_DISCOUNTS.multiCar,
    AUTO_DISCOUNTS.multiPolicy,
    AUTO_DISCOUNTS.homeowner,
    AUTO_DISCOUNTS.goodStudent,
    AUTO_DISCOUNTS.distantStudent,
    AUTO_DISCOUNTS.teenDriver,
  ],
  coverage: {
    uninsuredMotoristBodilyInjury: {
      modalContent: `Uninsured Motorist Bodily Injury (UMBI) pays the amount you are legally entitled to recover for damages from bodily injury, up to the limit of liability, when an insured person on your policy is hit by an uninsured driver or an unidentified (e.g. hit-and-run) driver. Mandatory coverage.`,
    },
  },
  coverageTextAlerts: {
    UMBI_UPDATE: ({ isRemoved, causeName }: TCoverageSideEffectsType) =>
      isRemoved
        ? ''
        : `Your Uninsured Motorist Bodily Injury limits may have changed based on the changes you've made to your ${causeName} coverage.`,
    UIMBI_UPDATE: ({ isRemoved, causeName }: TCoverageSideEffectsType) =>
      isRemoved
        ? ''
        : `Your Underinsured Motorist Bodily Injury limits may have changed based on the changes you've made to your ${causeName} coverage.`,
  },
  visibleCoverages: {
    protectionCoverages: [
      {
        label: 'Underinsured Motorist Bodily Injury',
        key: 'underinsured_motorist_bodily_injury_limit',
      },
      {
        label: 'Pet Passenger',
        key: 'pet_passenger',
      },
    ],
  },
  initialCoverageValues: {
    gap: 'false',
    temporary_ride: 'null',
    side_hustle: 'false',
  },
};
export default ToggleMOCopy;
